module.exports = __webpack_public_path__ + "assets/easy.01f1679ccce3f2923cb1af1e1f76c527.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/easy.png
 ** module id = 214
 ** module chunks = 0
 **/